import styled from 'styled-components';

export const FileUpload = styled.input`
  display: none;
`;

export const Wrapper = styled.label`
  cursor: pointer;

  button {
    pointer-events: none;
  }
`;
